import {
  hmplusVersionListConstants,
  hmplusVersionUploadConstants,
  hmplusVersionDeleteConstants,
  hmplusVersionConstants,
} from "../_redux-constants";

export function hmplusVersionListReducer(
  state = {
    hmplusVersionListLoading: false,
    hmplusVersionListData: null,
    hmplusVersionListError: null,

    hmplusVersionUploadLoading: false,
    hmplusVersionUploadData: null,
    hmplusVersionUploadError: null,

    hmplusVersionLoading: false,
    hmplusVersionData: null,
    hmplusVersionError: null,
  },
  action
) {
  switch (action.type) {
    case hmplusVersionListConstants.HMPLUSVERSION_LIST_LOADING:
      return Object.assign({}, state, {
        hmplusVersionListLoading: true,
        hmplusVersionListData: null,
        hmplusVersionListError: null,
      });
    case hmplusVersionListConstants.HMPLUSVERSION_LIST_SUCCESS:
      return Object.assign({}, state, {
        hmplusVersionListLoading: false,
        hmplusVersionListData: action.data,
      });
    case hmplusVersionListConstants.HMPLUSVERSION_LIST_FAILURE:
      return Object.assign({}, state, {
        hmplusVersionListLoading: false,
        hmplusVersionListData: null,
        hmplusVersionListError: action.error,
      });
    case hmplusVersionUploadConstants.HMPLUSVERSION_UPLOAD_LOADING:
      return Object.assign({}, state, {
        hmplusVersionUploadLoading: true,
        hmplusVersionUploadData: null,
        hmplusVersionUploadError: null,
      });
    case hmplusVersionUploadConstants.HMPLUSVERSION_UPLOAD_SUCCESS:
      return Object.assign({}, state, {
        hmplusVersionUploadLoading: false,
        hmplusVersionUploadData: action.data,
      });
    case hmplusVersionUploadConstants.HMPLUSVERSION_UPLOAD_FAILURE:
      return Object.assign({}, state, {
        hmplusVersionUploadLoading: false,
        hmplusVersionUploadData: null,
        hmplusVersionUploadError: action.error,
      });
    case hmplusVersionConstants.HMPLUSVERSION_LOADING:
      return Object.assign({}, state, {
        hmplusVersionLoading: true,
        hmplusVersionData: null,
        hmplusVersionError: null,
      });
    case hmplusVersionConstants.HMPLUSVERSION_SUCCESS:
      return Object.assign({}, state, {
        hmplusVersionLoading: false,
        hmplusVersionData: action.data,
      });
    case hmplusVersionConstants.HMPLUSVERSION_FAILURE:
      return Object.assign({}, state, {
        hmplusVersionLoading: false,
        hmplusVersionData: null,
        hmplusVersionError: action.error,
      });
    case hmplusVersionDeleteConstants.HMPLUSVERSION_DELETE_LOADING:
      return Object.assign({}, state, {
        hmplusVersionDeleteLoading: true,
        hmplusVersionDeleteData: null,
        hmplusVersionDeleteError: null,
      });
    case hmplusVersionDeleteConstants.HMPLUSVERSION_DELETE_SUCCESS:
      return Object.assign({}, state, {
        hmplusVersionDeleteLoading: false,
        hmplusVersionDeleteData: action.data,
      });
    case hmplusVersionDeleteConstants.HMPLUSVERSION_DELETE_FAILURE:
      return Object.assign({}, state, {
        hmplusVersionDeleteLoading: false,
        hmplusVersionDeleteData: null,
        hmplusVersionDeleteError: action.error,
      });
    default:
      return state;
  }
}
